import firebase from 'firebase/app';

export const usePersonLog = (cid, uid, date) => {
   return firebase.firestore().doc(`company/${cid}/people/${uid}/logs/${date}`);
};

export const useSpaceLog = (lid, sid, date) => {
   return firebase.firestore().doc(`location/${lid}/spaces/${sid}/logs/${date}`);
};
